import CONTENT_HEADER from '../plugins/content_header'
const [w,l] = [window,location]

export default function NEWS() {

  $(() => {
    CONTENT_HEADER();
    $.when(
      w.load['header'],
      w.load['footer']
    ).done(()=>{
      if(l.search == '?mode=detail&article=1'){
        $('header .p-gnav, footer .p-footer__nav').currentMenu({mode: 0,default: 999});
      } else {
        $('a[href = "/news/?mode=detail&article=1"]', 'header').removeClass('current');
        $('a[href = "/news/?mode=detail&article=1"]', 'footer').removeClass('current');
      }
    })
    w.load['footer'].done(()=>{
      if($.UA.is_mobile){
        $('.detailFooter').append(`<a class="p-news__back icon-list" href="/news/?mode=list" rel="external" title="記事一覧に戻る">記事一覧に戻る</a>`);
      }
    })
  })
}